import {createFileRoute, Outlet} from '@tanstack/react-router';

import {ImagesCacheProvider} from 'src/contexts/ImagesCacheProvider';

export const Route = createFileRoute('/model/samples')({
  component: ModelSamplesLayout,
});

function ModelSamplesLayout() {
  return (
    <ImagesCacheProvider mode='model-defect-book'>
      <Outlet />
    </ImagesCacheProvider>
  );
}
